import { ComponentPropsWithoutRef, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

const Section = ({
  children,
  className,
  id,
}: ComponentPropsWithoutRef<'section'>) => {
  return (
    <section
      className={twMerge('container mx-auto bg-brand-grayscale-1', className)}
      id={id}
    >
      {children}
    </section>
  )
}

const SectionContent = ({
  children,
  className,
}: ComponentPropsWithoutRef<'div'>) => {
  return (
    <div
      className={twMerge(
        'flex flex-col gap-10 px-5 py-10 sm:py-20 md:gap-28 md:px-20 lg:flex-row lg:items-center',
        className
      )}
    >
      {children}
    </div>
  )
}

const SectionColumn = ({
  children,
  className,
}: ComponentPropsWithoutRef<'div'>) => {
  return <div className={twMerge('flex flex-col', className)}>{children}</div>
}

const SectionRow = ({
  children,
  className,
}: ComponentPropsWithoutRef<'div'>) => {
  return <div className={twMerge('flex', className)}>{children}</div>
}

const SectionHeader = ({
  children,
  className,
}: ComponentPropsWithoutRef<'div'>) => {
  return (
    <div className={twMerge('flex flex-col gap-6', className)}>{children}</div>
  )
}

const SectionHeaderSubtitle = ({
  children,
  className,
}: ComponentPropsWithoutRef<'h2'>) => {
  return (
    <h2 className={twMerge('font-bold text-brand-green-primary-5', className)}>
      {children}
    </h2>
  )
}

const SectionHeaderTitle = ({
  children,
  className,
}: ComponentPropsWithoutRef<'h1'>) => {
  return (
    <h1
      className={twMerge(
        'text-2xl font-bold text-brand-grayscale-12 sm:leading-[2.75rem] md:text-[2rem]',
        className
      )}
    >
      {children}
    </h1>
  )
}

const SectionText = ({
  children,
  className,
}: ComponentPropsWithoutRef<'p'>) => {
  return (
    <p
      className={twMerge(
        'text-brand-grayscale-8 sm:text-lg sm:leading-7',
        className
      )}
    >
      {children}
    </p>
  )
}

export {
  Section,
  SectionColumn,
  SectionContent,
  SectionHeader,
  SectionHeaderSubtitle,
  SectionHeaderTitle,
  SectionRow,
  SectionText,
}
